import Vue from 'vue'

const components = [
    'Picture',
    'VText',
    'VButton',
    'VLine',
    'VBar',
    'VPie',
    'VIcon',
    'VInput',
    'Group',
    'RectShape',
    'VGauge',
    'LineUPG',
    'VSector',
    'CustomOHLC'
]

components.forEach(key => {
    Vue.component(key, () => import(`@/custom-component/${key}`))
})